import React from 'react';

interface Props {
  src: string;
  draggable?: boolean;
  className?: string;
  fallback: any;
  loading?: React.ReactNode;
  style?: {};
  maxWidth?: number;
  maxHeight?: number;
}

interface State {
  isError: boolean;
  isLoaded: boolean;
}

// TODO: remove this component and use Img instead. Also use ResizedImage
class Image extends React.Component<Props, State> {
  public image?: HTMLImageElement;
  public state: State;

  constructor(props: Props) {
    super(props);

    this.state = {
      isError: false,
      isLoaded: false,
    };
  }

  public onError() {
    this.setState({ isError: true });
  }

  public onLoad() {
    this.setState({ isError: false, isLoaded: true });
  }

  public getImage(imageElement: any): any {
    if (this.state.isError) {
      return this.props.fallback;
    }

    return imageElement;
  }

  public componentDidMount() {
    // if image hasn't completed loading, then let react handle error
    if (!this.image || !this.image.complete) {
      return;
    }

    // if image has finished loading and has 'errored'(errored when naturalWidth === 0)
    // then run the onError callback
    if (this.image.naturalWidth === 0) {
      this.onError();
    }

    // if everything ok call onLoad
    this.onLoad();
  }

  public render() {
    const { src, loading, className, maxWidth, maxHeight, draggable } =
      this.props;
    const { isLoaded } = this.state;

    return (
      <div>
        {!isLoaded && loading}

        {this.getImage(
          <img
            ref={(image) => (this.image = image || undefined)}
            src={src}
            onLoad={this.onLoad.bind(this)}
            onError={this.onError.bind(this)}
            style={{ maxWidth, maxHeight }}
            className={className}
            draggable={draggable}
          />,
        )}
      </div>
    );
  }
}

export default Image;
